export function Minus(
  props: React.SVGAttributes<SVGSVGElement>
): React.ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 341.333 341.333"
      {...props}
    >
      <rect y="149.333" width="341.333" height="42.667" fill="currentColor" />
    </svg>
  );
}
